import React, { useState, useRef, useEffect } from "react";
import {
  ChevronDown,
  ChevronUp,
  UserRound
} from "lucide-react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase"; // adjust the path if needed
import { logoutRestaurant } from "../services/auth"; // adjust the path if needed

// import "./Header.css";

export function Header({ title, subtitle, action, }) {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  // close the profile button when clicking outside
  useEffect(() => {

    function handleClickOutside(event) {

      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {

        setShowMenu(false);

      }

    }

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

    };

  }, []);

  const handleLogout = async () => {

    try {

      //--------------------------------------------------
      // Clear backend session
      //--------------------------------------------------

      await logoutRestaurant();

      //--------------------------------------------------
      // Sign out Firebase
      //--------------------------------------------------

      await signOut(auth);

      //--------------------------------------------------
      // Clear local storage
      //--------------------------------------------------

      localStorage.removeItem(

        "selectedOutletUid"

      );

      //--------------------------------------------------
      // Close dropdown
      //--------------------------------------------------

      setShowMenu(false);

      //--------------------------------------------------
      // Redirect to login
      //--------------------------------------------------

      window.location.href = "/login";

    }

    catch (error) {

      console.error(

        "Failed to log out:",

        error

      );

    }

  };

  return (
    <>

      {/* Top Navigation */}

      <header className="top-header">

        <div />

        <div className="top-header-right">

          <div className="profile-menu" ref={menuRef}>

            <button
              className="profile-button"
              onClick={() => setShowMenu(!showMenu)}
            >

              <div className="profile-avatar">
                <UserRound size={22} />
              </div>

              {
                showMenu ?
                  <ChevronUp size={18} /> :
                  <ChevronDown size={18} />
              }

            </button>

            {showMenu && (

              <div className="profile-dropdown">

                <button
                  className="profile-dropdown-item"
                  onClick={handleLogout}
                >

                  Log Out

                </button>

              </div>

            )}

          </div>

        </div>

      </header>

      {/* Page Heading */}

      <div className="page-header">

        <div>

          <h1>{title}</h1>

          <p>{subtitle}</p>

        </div>

        {action}

      </div>

    </>
  );
}